import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import cssVars from 'css-vars-ponyfill';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';

if (environment.production) {
  enableProdMode();
}

cssVars({
  watch: true,
  silent: true
});

// Pre-init error buffer: capture errors before Sentry is initialized (CVX-5922)
(window as any).__sentryBuffer = [];
const MAX_BUFFER = 20;

const onError = (event: ErrorEvent) => {
  const buf = (window as any).__sentryBuffer;
  if (!Array.isArray(buf)) return;
  if (buf.length >= MAX_BUFFER) buf.shift();
  buf.push({
    type: 'error',
    error: event.error,
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    timestamp: Date.now()
  });
};

const onRejection = (event: PromiseRejectionEvent) => {
  const buf = (window as any).__sentryBuffer;
  if (!Array.isArray(buf)) return;
  if (buf.length >= MAX_BUFFER) buf.shift();
  buf.push({
    type: 'rejection',
    reason: event.reason,
    timestamp: Date.now()
  });
};

window.addEventListener('error', onError);
window.addEventListener('unhandledrejection', onRejection);

(window as any).__sentryBufferCleanup = () => {
  window.removeEventListener('error', onError);
  window.removeEventListener('unhandledrejection', onRejection);
};

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
